// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4c36c2b6","button":"_7361c953"};